import { OAuthProvider, getAuth } from "firebase/auth";

const authApple = getAuth(); 
const providerApple = new OAuthProvider("apple.com");
export { authApple, providerApple };
